export const phantomIconSvg = `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z" fill="#FF4136"/>
    <path d="M12 5C8.13 5 5 8.13 5 12C5 15.87 8.13 19 12 19C15.87 19 19 15.87 19 12C19 8.13 15.87 5 12 5ZM12 17C9.24 17 7 14.76 7 12C7 9.24 9.24 7 12 7C14.76 7 17 9.24 17 12C17 14.76 14.76 17 12 17Z" fill="url(#paint0_radial_1_2)"/>
    <defs>
        <radialGradient id="paint0_radial_1_2" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(12 12) rotate(90) scale(7)">
            <stop stop-color="#FFC400"/>
            <stop offset="1" stop-color="#FF4136" stop-opacity="0"/>
        </radialGradient>
    </defs>
</svg>
`;

export const reaperIconSvg = `
<svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18 3L33 18L18 33L3 18L18 3Z" fill="#9400D3" stroke="#FF00FF" stroke-width="2"/>
    <path d="M18 10L26 18L18 26L10 18L18 10Z" fill="rgba(0,0,0,0.5)"/>
</svg>
`;
